var _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 148,
    viewBox: "0 0 137 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_665_5879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0068 89.1312V68.3806C49.0068 57.6786 57.6854 49 68.3875 49C79.0895 49 87.7681 57.6786 87.7681 68.3806V89.1255",
    stroke: "#9146FF",
    strokeWidth: 9.21181,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0068 89.1312V68.3806C49.0068 57.6786 57.6854 49 68.3875 49C79.0895 49 87.7681 57.6786 87.7681 68.3806V89.1255",
    stroke: "#9146FF",
    strokeWidth: 9.21181,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_665_5879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.8323 76.5205H42.9417C39.1079 76.5205 36 79.6284 36 83.4622V111.997C36 115.831 39.1079 118.939 42.9417 118.939H93.8323C97.6661 118.939 100.774 115.831 100.774 111.997V83.4622C100.774 79.6284 97.6661 76.5205 93.8323 76.5205Z",
    fill: "url(#paint0_linear_665_5879)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9417 77.0239H93.8323C97.3881 77.0239 100.271 79.9064 100.271 83.4622V111.997C100.271 115.553 97.3881 118.436 93.8323 118.436H42.9417C39.3859 118.436 36.5034 115.553 36.5034 111.997V83.4622C36.5034 79.9064 39.3859 77.0239 42.9417 77.0239Z",
    stroke: "url(#paint1_linear_665_5879)",
    strokeWidth: 1.00676
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_665_5879",
    x: 0.103642,
    y: 0.0972939,
    width: 136.568,
    height: 133.331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.1486,
    result: "effect1_foregroundBlur_665_5879"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_665_5879",
    x: 26.9392,
    y: 67.4597,
    width: 82.8955,
    height: 60.5396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.5304
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_665_5879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_665_5879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_665_5879",
    x1: 39.6569,
    y1: 116.544,
    x2: 74.1488,
    y2: 63.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_665_5879",
    x1: 40.5723,
    y1: 79.8566,
    x2: 72.2283,
    y2: 131.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.76d01afebfe13a922d8e8d83f2ad9959.svg";
export { ForwardRef as ReactComponent };